import React from "react";
import Typed from "react-typed";

const textLines = [
  "Frontend Developer",
  "Backend Developer",
  "Mobile App Developer",
  "Freelancer",
];

function Type() {
  return (
    <div>
      <Typed strings={textLines} typeSpeed={60} backSpeed={60} loop  />
    </div>
  );
}

export default Type;
